<template>
  <div class="kongzhi">
    <!-- 预约控制 -->
    <div class="top">
      <p class="top-title">工作日设置</p>
      <Checkbox-group v-model="fruit">
        <Checkbox
          class="check-box"
          v-for="(item, index) in checkdata"
          :key="index"
          :label="item.id"
          ><span>{{ item.name }}</span>
        </Checkbox>
      </Checkbox-group>
      <div class="data">
        <div class="p-left">
          特殊工作日期 :
        </div>
        <div class="p-right">
          <div class="data-cont" v-for="(item, index) in dataLIst" :key="index">
            <Date-picker
              class="data-pick"
              type="daterange"
              v-model="item.value"
              :options="options2"
              placement="bottom-start"
              placeholder="选择日期"
            ></Date-picker>
            <Icon
              v-show="index !== 0"
              @click="reduceData(item, index)"
              class="i-icon"
              type="ios-remove-circle-outline"
            />
            <Icon
              v-show="index == 0"
              class="i-icon i-icons"
              type="ios-remove-circle-outline"
            />
            <Icon
              @click="addData(item, index)"
              class="i-icon"
              type="ios-add-circle-outline"
            />
          </div>
        </div>
        <div class="p-bottom">
          <div class="p-left">
            预约日期说明 :
          </div>
          <div class="p-right">
            <div class="data-cont">
              <Input
                v-model="note"
                class="data-pick"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 3 }"
                placeholder="请输入对可预约日期的说明"
              />
            </div>
          </div>
        </div>
        <div class="p-bottom">
          <div>
            <p>
              注：1、当工作日星期设置与特殊工作日期冲突时，特殊工作日期为准。
            </p>
            <p class="secondp">
              2、当特殊工作日期逾期后7天时，系统自动清除特殊日期记录。
            </p>
          </div>
        </div>
      </div>
      <Button class="title-btn fourSize" type="success" ghost @click="postData"
        >保存</Button
      >
    </div>
    <div class="top">
      <p class="top-title">休息日设置</p>
      <div class="data">
        <div class="p-left">
          特殊休息日期 :
        </div>
        <div class="p-right">
          <div
            class="data-cont"
            v-for="(item, index) in xiudataLIst"
            :key="index"
          >
            <Date-picker
              placement="bottom-start"
              class="data-pick"
              type="daterange"
              v-model="item.value"
              :options="options2"
              placeholder="选择日期"
            ></Date-picker>
            <Icon
              v-show="index !== 0"
              @click="reducexiuxiData(item, index)"
              class="i-icon"
              type="ios-remove-circle-outline"
            />
            <Icon
              v-show="index == 0"
              class="i-icon i-icons"
              type="ios-remove-circle-outline"
            />
            <Icon
              @click="addxiuxiData(item, index)"
              class="i-icon"
              type="ios-add-circle-outline"
            />
          </div>
        </div>
        <div class="p-bottom">
          <div>
            <p>注：1、当工作日设置与休息日设置冲突时，休息日期为准。</p>
            <p class="secondp">
              2、当特殊日期逾期后7天时，系统自动清除特殊日期记录。
            </p>
          </div>
        </div>
      </div>
      <Button
        class="title-btn fourSize"
        type="success"
        ghost
        @click="postData(2)"
        >保存</Button
      >
    </div>
    <div class="top tops">
      <p class="top-title">单日最多预约人数</p>
      <div class="data">
        <span class="span">{{ peopleNum || 0 }} 人</span>
      </div>
      <Button class="title-btn fourSize" type="success" ghost @click="isXiuShow"
        >修改</Button
      >
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->

    <!--  -->
    <!--  -->
    <Modal
      class="ivumodal"
      v-model="isShow"
      title="修改"
      footer-hide
      width="500"
    >
      <div class="ive-cont">
        限制控制 :
        <Radio-group v-model="animal" @on-change="getRadio">
          <Radio label="无限制" style="margin-left:40px;">无限制</Radio>
          <Radio label="限制" style="margin-left:45px;">限制</Radio>
        </Radio-group>
        <div class="input-max" v-show="maxInputIsshow">
          限制数量 :
          <i-input
            v-model="maxNum"
            type="number"
            placeholder="请输入大于20的数字"
            style="width: 250px"
          ></i-input>
        </div>
        <p v-show="isPshow" class="ivumodal-p">请输入限制数量大于20得数字</p>
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="cancel(1)"
          >取消</Button
        >
        <Button class="btn sure" type="success" ghost @click="ok(1)"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
    import {
        selectWorkDay,
        setWorkDay,
        selectRestDay,
        setRestDay,
        selectPeopleNum,
        setPeopleNum
    } from "../servers/api";
    export default {
        name: "kongzhi",
        data() {
            return {
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                checkdata: [{
                    name: "周一",
                    id: "1"
                }, {
                    name: "周二",
                    id: "2"
                }, {
                    name: "周三",
                    id: "3"
                }, {
                    name: "周四",
                    id: "4"
                }, {
                    name: "周五",
                    id: "5"
                }, {
                    name: "周六",
                    id: "6"
                }, {
                    name: "周日",
                    id: "7"
                }],
                fruit: [],
                disabledSingle: true,
                options2: {
                    shortcuts: [{
                        text: "最近一周",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        }
                    }, {
                        text: "最近一个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        }
                    }, {
                        text: "最近三个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        }
                    }]
                },
                dataLIst: [{
                    id: 1,
                    value: []
                }],
                xiudataLIst: [{
                    id: 1,
                    value: []
                }],
                isShow: false, //修改
                animal: "无限制",
                maxNum: "",
                isPshow: false,
                maxInputIsshow: false,
                peopleNum: "无限制",
                note: ""

                // radioList:[
                //     {id:1,value:'无限制'},
                //     {id:2,value:'限制'}
                // ]
            };
        },
        methods: {
            selectWorkDay() {
                //查询工作日
                this.isiconfontshow = true;
                selectWorkDay({}).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.fruit = res.data.data.weekDays || [];
                        let list = res.data.data.specialWeekDays || [];
                        this.dataLIst = [];
                        this.note = res.data.data.note || "";
                        for (let i = 0; i < list.length; i++) {
                            this.dataLIst.push({
                                value: [list[i].slice(0, 10), list[i].slice(13, 23)]
                            });
                        }
                        if (this.dataLIst.length == 0) {
                            this.dataLIst.push({
                                value: []
                            });
                        }
                    }
                });
            },
            selectRestDay() {
                //查询休息日
                this.isiconfontshow = true;
                selectRestDay({}).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        let list = res.data.data.restDays || [];
                        this.xiudataLIst = [];
                        for (let i = 0; i < list.length; i++) {
                            this.xiudataLIst.push({
                                value: [list[i].slice(0, 10), list[i].slice(13, 23)]
                            });
                        }
                        if (this.xiudataLIst.length == 0) {
                            this.xiudataLIst.push({
                                value: []
                            });
                        }
                    }
                });
            },
            selectPeopleNum() {
                this.isiconfontshow = true;
                selectPeopleNum({}).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        if (
                            res.data.data[0] &&
                            res.data.data[0].peopleNum &&
                            res.data.data[0].peopleNum > -1
                        ) {
                            this.peopleNum = res.data.data[0].peopleNum;
                        } else {
                            this.peopleNum = "无限制";
                        }
                    }
                });
            },
            cancel() {
                //取消
                this.isShow = false;
                this.maxNum = "";
                this.animal = "无限制";
                this.maxInputIsshow = false;
                this.isPshow = false;
            },
            ok() {
                //确定
                // this.isShow = false;
                let num = "";
                if (this.animal == "限制") {
                    if (this.maxNum > 20) {
                        this.isPshow = false;
                        num = this.maxNum;
                        this.setPeopleNum(num);
                    } else {
                        this.isPshow = true;
                    }
                } else {
                    num = "-1";
                    this.setPeopleNum(num);
                }
            },
            setPeopleNum(num) {
                //设置限制
                this.isiconfontshow = true;
                let params = {
                    peopleNum: num
                };
                setPeopleNum(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.isShow = false;
                        this.selectPeopleNum();
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            isXiuShow() {
                this.isShow = true;
            },
            getRadio(item) {
                //獲取限制
                if (item == "限制") {
                    this.maxInputIsshow = true;
                    this.isPshow = false;
                } else {
                    this.maxInputIsshow = false;
                    this.isPshow = false;
                }
            },
            reduceData(item, index) {
                //删除
                this.dataLIst.splice(index, 1);
            },
            reducexiuxiData(item, index) {
                //删除
                this.xiudataLIst.splice(index, 1);
            },
            addData(item, index) {
                //添加特殊日期
                let par = {
                    id: index + 1,
                    value: ""
                };
                this.dataLIst.push(par);
            },
            addxiuxiData(item, index) {
                let par = {
                    id: index + 1,
                    value: ""
                };
                this.xiudataLIst.push(par);
            },
            postData(index) {
                //保存
                if (index == 2) {
                    let list = [];
                    if (this.xiudataLIst.length == 1) {
                        for (let i = 0; i < this.xiudataLIst.length; i++) {
                            if (
                                this.xiudataLIst[i].value &&
                                this.xiudataLIst[i].value[0] &&
                                new Date(this.xiudataLIst[i].value[0]) == "tInvalid Date"
                            ) {
                                this.xiudataLIst = [];
                            }
                        }
                    } else if (this.xiudataLIst.length == 0) {
                        this.xiudataLIst = [];
                    }
                    this.isiconfontshow = true;
                    for (let i = 0; i < this.xiudataLIst.length; i++) {
                        if (
                            this.xiudataLIst[i].value[0] &&
                            this.xiudataLIst[i].value[0] !== ""
                        ) {
                            list.push(this.xiudataLIst[i].value);
                        }
                    }
                    let workDayList = [];
                    for (let i = 0; i < list.length; i++) {
                        let d = new Date(list[i][0]);
                        list[i][0] =
                            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
                        let ds = new Date(list[i][1]);
                        list[i][1] =
                            ds.getFullYear() + "-" + (ds.getMonth() + 1) + "-" + ds.getDate();
                        workDayList.push(list[i][0] + "_" + list[i][1]);
                    }
                    let params = {
                        restDayList: workDayList.join(",")
                    };
                    setRestDay(params).then(res => {
                        if (res.data.code == 1) {
                            this.selectRestDay();
                            this.isiconfontshow = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                } else {
                    if (this.dataLIst.length == 1) {
                        for (let i = 0; i < this.dataLIst.length; i++) {
                            if (
                                this.dataLIst[i].value &&
                                this.dataLIst[i].value[0] &&
                                new Date(this.dataLIst[i].value[0]) == "tInvalid Date"
                            ) {
                                this.dataLIst = [];
                            }
                        }
                    } else if (this.dataLIst.length == 0) {
                        this.dataLIst = [];
                    }
                    this.isiconfontshow = true;
                    let list = [];
                    for (let i = 0; i < this.dataLIst.length; i++) {
                        if (this.dataLIst[i].value[0] && this.dataLIst[i].value[0] !== "") {
                            list.push(this.dataLIst[i].value);
                        }
                    }
                    let workDayList = [];
                    for (let i = 0; i < list.length; i++) {
                        let d = new Date(list[i][0]);
                        list[i][0] =
                            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
                        let ds = new Date(list[i][1]);
                        list[i][1] =
                            ds.getFullYear() + "-" + (ds.getMonth() + 1) + "-" + ds.getDate();
                        workDayList.push(list[i][0] + "_" + list[i][1]);
                    }
                    let params = {
                        weekDays: this.fruit.join(","),
                        workDayList: workDayList.join(","), //2019-08-01_2019-08-02
                        note: this.note
                    };
                    setWorkDay(params).then(res => {
                        if (res.data.code == 1) {
                            this.selectWorkDay();
                            this.isiconfontshow = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                }
            }
        },
        created() {
            this.selectWorkDay();
            this.selectRestDay();
            this.selectPeopleNum();
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .ive-cont {
        padding-left: 50px;
    }
    
    .ivumodal-p {
        margin-top: 15px;
        color: red;
    }
    
    .kongzhi {
        padding: 15px;
        padding-top: 0;
        font-size: 13px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .top {
            padding-left: 15px;
            padding-top: 15px;
            // padding-bottom: 15px;
            border-bottom: 1px dashed #53cac3;
            position: relative;
            .top-title {
                font-size: 16px;
            }
        }
        .tops {
            border: none;
        }
        .check-box {
            margin-left: 50px;
            margin-top: 15px;
            span {
                padding-left: 10px;
            }
        }
        .data {
            padding: 15px;
            padding-left: 30px;
            .secondp {
                padding-left: 27px;
                margin-top: 5px;
            }
            .span {
                margin-left: 200px;
                font-size: 30px;
                color: #53cac3;
            }
        }
        .data-pick {
            margin-left: 15px;
            width: 250px;
        }
        .i-icon {
            font-size: 25px;
            font-weight: 700;
            line-height: 30px;
            vertical-align: middle;
            color: #53cac3;
            margin-left: 15px;
            cursor: pointer;
        }
        .i-icons {
            color: #fff;
        }
        .p-left {
            float: left;
            line-height: 60px;
        }
        .p-right {
            float: left;
        }
        .p-bottom {
            clear: both;
            padding-top: 15px;
        }
        .data-cont {
            margin-top: 15px;
        }
        .bottom-left {
            float: left;
            // padding-right: 250px;
            width: 670px;
        }
        .clear {
            clear: both;
        }
        .title-btn {
            position: absolute;
            left: 670px;
            bottom: 15px;
        }
        .check {
            padding-left: 40px;
            margin-top: 15px;
        }
    }
    
    .input-max {
        margin-top: 15px;
        .ivu-input-wrapper {
            margin-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/yuyue/kongzhi.vue